<template>
  <nav id="header" class="shadow fixed z-10 w-full transition-all" :class="{'backdrop-blur border-b-2 h-16 py-2': sticky, 'h-32 py-4': !sticky}">
    <slot />
  </nav>
</template>

<script>
export default {
  name: "sticky-header",
  data: function () {
    return {
      sticky: false
    }
  },
  methods: {
    handleScroll: function() {
      if (window.pageYOffset > 0) {
        this.sticky = true
      } else {
        this.sticky = false
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>

</style>